import { Component, EventEmitter, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { CreateDiagnosticVM, DiagnosticsList, DiagnosticVM } from 'src/app/Elearning-Models';
import { IAPIService } from '../../../../../Services/API-Service/IAPIService';

@Component({
  selector: 'app-select-diagnostics-dialog',
  templateUrl: './select-diagnostics-dialog.component.html',
  styleUrls: ['./select-diagnostics-dialog.component.scss']
})
export class SelectDiagnosticsDialogComponent implements OnInit {
  diagnosticSelected = new EventEmitter<any>();
  title: string;
  diagnosticsListLoading: boolean = false;
  diagnosticsList: DiagnosticsList[];
  filteredDiagnostics: Observable<DiagnosticsList[]>;
  diagnosticsSelectControl = new FormControl('');
  // selectedAssignmentID: number = 0;
  selectedDimDistrictExamID: number = 0;

  hbcID: number;

  constructor(
    private APIService: IAPIService,
    public dialogRef: MatDialogRef<SelectDiagnosticsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data) {
      this.title = data.title;
      this.hbcID = data.hbClassID;
    }

  ngOnInit(): void {

    this.getDiagnosticsList();
  }

  getDiagnosticsList = () => {
    this.diagnosticsListLoading = true;
    this.APIService.GetDiagnosticListForTeacher(this.hbcID).subscribe(
      (response: DiagnosticsList[]) => {
        this.diagnosticsList = response;
        this.filteredDiagnostics = this.diagnosticsSelectControl.valueChanges.pipe(
          startWith(''),
          map((value) => this._filterDiagnosticsByName(value))
        );
        this.diagnosticsListLoading = false;
    });
  }

  private _filterDiagnosticsByName(value: string): DiagnosticsList[] {
    const filterValue = value.toLowerCase();
    return this.diagnosticsList.filter((option) =>
      option.ExamDesc.toLowerCase().includes(filterValue)
    );
  }

  clearDiagnosticValue = () => {
    this.diagnosticsSelectControl.setValue('');
    this.setDimDistrictExamID(0);
  }

  setDimDistrictExamID = (dimDistrictExamID: number) => {
    this.selectedDimDistrictExamID = dimDistrictExamID;
  }

  onSubmit = () => {
    var createModel = new CreateDiagnosticVM(this.selectedDimDistrictExamID, this.data.hbClassID);

    // create the record
    this.APIService.CreateDiagnostic(createModel).subscribe(
      (response: DiagnosticVM) => {
        this.diagnosticSelected.emit(response.DiagnosticExamID);
        this.dialogRef.close();
    });
  }

  onCancel = () => {
    this.dialogRef.close();
  }

}
